/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import MembershipSettingRepository from '../../repositories/Admin/MembershipSettingRepository';
import { createRestSlice } from '../../utils/RestSlice';

const membershipSettingsRestSlice = createRestSlice({
  resource: 'membershipSetting',
  repository: MembershipSettingRepository,
  slices: ['loadMembershipSettings', 'updateMembershipSetting'],
});

const initialState = {
  ...membershipSettingsRestSlice.initialState,
};

const membershipSettingsSlice = createSlice({
  name: 'membershipSettings',
  initialState,
  reducers: {
    ...membershipSettingsRestSlice.reducers,
  },
});

export default membershipSettingsSlice.reducer;

export const membershipSettingsRestHooks = membershipSettingsRestSlice.hooks(
  membershipSettingsSlice,
  ['admin', 'MembershipSettingsSlice']
);
